const GuarantorView = (data) => {
  return (
    <div>
      <h1 className="text-xl mb-4 font-bold">Guarantor</h1>
      {data?.data?.map((eachGuarantor, index) => {
        return (
          <div
            key={index}
            className={`grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 bg-neutral-100 p-4 rounded-sm`}
          >
            <div>
              <h3 className="font-semibold text-lg text-gray-900">FullName</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachGuarantor?.name || "No Name specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">Address</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachGuarantor?.address || "No Address specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">
                Contact Email
              </h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachGuarantor?.email || "No contact specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">
                Contact Phone
              </h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachGuarantor?.phone || "Not specified"}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GuarantorView;
